import { render, staticRenderFns } from "./Scroller.vue?vue&type=template&id=4a00b706&scoped=true&"
import script from "./Scroller.vue?vue&type=script&lang=ts&"
export * from "./Scroller.vue?vue&type=script&lang=ts&"
import style0 from "./Scroller.vue?vue&type=style&index=0&id=4a00b706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00b706",
  null
  
)

export default component.exports